@use "styles/abstracts/variables" as v;

.footerNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 8px 0 16px;
  flex-wrap: wrap;

  @media (max-width: 560px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.left,
.right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.right {
  margin-left: auto;

  button.actionBtn {
    color: v.$palette-white;
    background-color: v.$palette-orange-2;

    @media (pointer: fine) {
      &:hover {
        color: v.$palette-white;
        background-color: v.$palette-orange-3;
      }
    }
  }

  @media (max-width: 560px) {
    margin-left: 0;
    width: 100%;

    > * {
      flex: 1 1 auto;
    }
  }
}

.tooltipContent {
  max-width: 240px;
  text-align: center;
}
